/** 11sight aded packages BEGIN */
import { withStyles } from '@mui/styles';
import * as IISightAPI from 'common/helpers/api';
import { ChatInput as JitsiChatInput, mapStateToProps, } from 'jitsi/chat/components/web/ChatInput';
import { IconAttachment, IconFaceSmile } from 'jitsi/base/icons/svg';
/** 11sight aded packages END */
import React from 'react';
import { connect } from 'react-redux';
import { random } from 'lodash';
import { isMobileBrowser } from 'jitsi/base/environment/utils';
import { translate } from 'jitsi/base/i18n/functions';
import { IconSend } from 'jitsi/base/icons/svg';
import Button from 'jitsi/base/ui/components/web/Button';
import Input from 'jitsi/base/ui/components/web/Input';
import SmileysPanel from './SmileysPanel';
import cx from 'clsx';
import { BUTTON_TYPES } from 'jitsi/base/ui/constants.any';
import { showErrorNotification } from 'jitsi/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from 'jitsi/notifications/constants';
import { Slide } from './uploadingCarousel/Slide';
import { Carousel } from 'features/base/ui/components/Carousel';
import { Attachment } from './attachments';
// 11sight lines added END
const styles = (theme) => {
    return {
        container: {
            boxSizing: 'border-box',
            marginTop: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch !important',
            position: 'relative',
            borderTop: `1px solid ${theme.palette.iisightGray200}`,
        },
        chatInput: {
            padding: theme.spacing(2),
            gap: theme.spacing(1),
            display: 'flex',
            alignItems: 'flex-end',
        },
        sendButton: {
            background: 'none',
            '& svg': {
                fill: `${theme.palette.iisightBrand} !important`,
            },
        },
        inputContainer: {
            flex: 1,
        },
        chatTextArea: {
            '& textarea': {
                background: 'none',
                color: theme.palette.iisightDefaultText,
                border: 'none',
            },
        },
        carouselContainer: {
            width: '100%',
            padding: `${theme.spacing(2)} 0`,
            border: 'none',
        },
        leftIcons: {
            display: 'flex',
            alignItems: 'center',
        },
        icon: {
            // padding: theme.spacing(2),
            '& svg, & path': {
                fill: `${theme.palette.iisightBrand} !important`,
            },
            '&:disabled': {
                background: 'none',
                '& svg, & path': {
                    fill: `${theme.palette.iisightGray400} !important`,
                },
            },
        },
        smileysContainer: {
            width: '100%',
            margin: 0,
            backgroundColor: 'initial !important',
            overflow: 'visible',
        },
        smileysInput: {
            width: '100%',
        },
    };
};
/**
 * Implements a React Component for drafting and submitting a chat message.
 *
 * @augments Component
 */
class ChatInput extends JitsiChatInput {
    /**
     * Initializes a new {@code ChatInput} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            showSmileysPanel: false,
            // 11sight added lines BEGIN
            blockedFileExtensions: [],
            files: [],
            // 11sight added lines END
        };
        this._textArea = React.createRef();
        this.removeFile = this.removeFile.bind(this);
        this._onFileChange = this._onFileChange.bind(this);
        this.onUploadError = this.onUploadError.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
    }
    // 11sight lines added BEGIN
    /**
     * Loads black listed file extensions from the API.
     *
     * @returns {void}
     */
    async getFileExtensions() {
        try {
            const { data } = await IISightAPI.getBlockedExtension();
            this.setState({ blockedFileExtensions: data });
        }
        catch { }
    }
    componentDidMount() {
        this.getFileExtensions();
    }
    /**
     * Trigerred when new file is selected.
     *
     * @param {Object} event - File event.
     * @returns {void}
     */
    _onFileChange(event) {
        const { files: rawFiles } = event.target;
        const files = [...(rawFiles || [])];
        event.target.form?.reset();
        if (!this.state.blockedFileExtensions)
            return this.props.dispatch(showErrorNotification({ titleKey: 'notify.UnexpectedErrorHappened' }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        let errored = false;
        files.forEach((file) => {
            const { name } = file;
            const extension = name.split('.').at(-1);
            if (extension && this.state.blockedFileExtensions.includes(extension)) {
                errored = true;
                this.props.dispatch(showErrorNotification({ titleKey: 'notify.UnsupportedFileExtension' }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
            }
            else if (file.size > 25 * 1024 * 1024) {
                errored = true;
                this.props.dispatch(showErrorNotification({ titleKey: 'notify.UnsupportedFileSize' }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
            }
            if (errored)
                return;
            file.id = `${file.size}-${Date.now()}-${random(0, 50)}`;
        });
        if (errored)
            return;
        this.setState((state) => ({ ...state, files: [...state.files, ...files] }));
    }
    onUploadError(fileName) {
        this.props.dispatch(showErrorNotification({ titleKey: 'notify.ErrorInFileUploading' }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
        if (fileName) {
            this.setState((state) => ({
                ...state,
                files: this.state.files.map((file) => {
                    if (file.name === fileName)
                        delete file.uploading;
                    return file;
                }),
            }));
        }
    }
    async uploadFile(file) {
        this.setState((state) => ({
            ...state,
            files: state.files.map((stateFile) => {
                if (stateFile.name === file.name)
                    stateFile.uploading = true;
                return stateFile;
            }),
        }));
        const data = new FormData();
        data.append('meeting_attachment[attachment]', file);
        const response = await IISightAPI.uploadFile(data).catch(() => this.onUploadError(file.name));
        if (!response)
            return;
        this.setState((state) => ({
            ...state,
            files: state.files.filter((stateFile) => stateFile.name !== file.name),
        }));
        this.props.onSend(JSON.stringify(response.data.json.attachment));
        return response.data;
    }
    /**
     * Trigerred when file upload is started.
     *
     * @param {Object} event - File event.
     * @returns {void}
     */
    async _onSubmitMessage() {
        const message = this.state.message.trim();
        if (message) {
            await this.props.onSend(message);
            this.setState({ message: '' });
        }
        if (this.state.files.length === 0)
            return;
        const responses = await Promise.all(this.state.files.map(this.uploadFile)).catch(this.onUploadError);
        if (!responses || responses.includes(undefined))
            return;
        this.setState({ ...this.state, files: [] });
    }
    removeFile(fileIndex) {
        this.setState((state) => ({
            ...state,
            files: state.files.filter((_, index) => index !== fileIndex),
        }));
    }
    // 11sight lines added END
    render() {
        const { classes, _areSmileysDisabled, t } = this.props;
        const attachmentClassName = `${'enableAttachmentIcon'}`;
        return (React.createElement("form", { className: classes.container, id: 'chat-input' },
            !_areSmileysDisabled && this.state.showSmileysPanel && (React.createElement("div", { className: cx('smiley-input', classes.smileysInput) },
                React.createElement("div", { className: cx('smileys-panel', classes.smileysContainer) },
                    React.createElement(SmileysPanel, { onSmileySelect: this._onSmileySelect })))),
            this.state.files.length !== 0 && (React.createElement("div", { className: classes.carouselContainer },
                React.createElement(Carousel, { px: 2, gap: 2 }, this.state.files.map((file, index) => {
                    return (React.createElement(Slide, { key: file.id, uploading: file.uploading, onRemove: () => this.removeFile(index) },
                        React.createElement(Attachment, { height: 60, variant: 'square', name: file.name, size: file.size, type: file.type, url: URL.createObjectURL(file) })));
                })))),
            React.createElement("div", { className: classes.chatInput },
                (!window.APP.room?.conference_options
                    ?.disable_file_upload ||
                    !window.APP.room?.vconnect) && (React.createElement("div", { className: classes.leftIcons },
                    React.createElement("label", { className: cx(classes.icon, attachmentClassName), htmlFor: 'file-input' },
                        React.createElement(Button, { onClick: () => document.getElementById('file-input')?.click(), className: classes.icon, type: BUTTON_TYPES.TERTIARY, accessibilityLabel: t('chat.attachFiles'), icon: IconAttachment, size: isMobileBrowser() ? 'large' : 'medium' })),
                    React.createElement("input", { className: 'hidden', id: 'file-input', onChange: this._onFileChange, type: 'file', multiple: true }),
                    React.createElement(Button, { className: classes.icon, type: BUTTON_TYPES.TERTIARY, accessibilityLabel: t('chat.smileysPanel'), icon: IconFaceSmile, size: isMobileBrowser() ? 'large' : 'medium', onClick: this._toggleSmileysPanel }))),
                React.createElement("div", { className: classes.inputContainer },
                    React.createElement(Input, { className: classes.chatTextArea, id: 'chat-input-messagebox', maxRows: 5, onChange: this._onMessageChange, onKeyPress: this._onDetectSubmit, placeholder: t('chat.messagebox'), ref: this._textArea, textarea: true, value: this.state.message })),
                React.createElement("div", null,
                    React.createElement(Button, { className: classes.icon, 
                        // className='send-button'
                        type: BUTTON_TYPES.TERTIARY, accessibilityLabel: t('chat.sendButton'), disabled: !this.state.message.trim() && this.state.files.length === 0, icon: IconSend, onClick: this._onSubmitMessage, size: isMobileBrowser() ? 'large' : 'medium' })))));
    }
}
export default withStyles(styles)(translate(connect(mapStateToProps)(ChatInput)));
